import { FlowRestResponseBodyFormat } from 'flow-schema';

import { api } from 'common';

import { MontageOnBaseFormFields } from './FormFields';
import { MontageOnBaseDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const montageOnBaseConfig: BlockConfigProps<api.FlowDefinition.MontageOnBaseBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'MontageOnBaseRestApi',
  defaultConfig: {
    apiInstanceId: '',
    apiInstanceBaseUrl: undefined,
    method: api.Orchestrator.ApiInstanceFhir.ApiInstanceFhirMethod.GET,
    endpoint: '',
    responseBodyFormat: FlowRestResponseBodyFormat.AutoDetect,
  },
  configFields: {
    schema: api.FlowDefinition.MontageOnBaseBlockConfigSchema,
    FormFields: MontageOnBaseFormFields,
  },
  documentationMarkdown: MontageOnBaseDocumentationMarkdown,
};
